export default {
  // 是否已生效
  isValid: {
    list: [
      {
        value: -1,
        label: '全部数据状态'
      },
      {
        value: 1,
        label: '已生效'
      },
      {
        value: 0,
        label: '已失效'
      }
    ]
  },
  // 启用状态
  activeStatus: {
    list: [
      {
        value: -1,
        label: '全部启用状态'
      },
      {
        value: 1,
        label: '已启用'
      },
      {
        value: 0,
        label: '未启用'
      }
    ]
  },
  // 科目分类
  // accountElement: {
  //   list: [
  //     {
  //       value: -1,
  //       label: '全部科目分类'
  //     },
  //     {
  //       value: 1,
  //       label: '资产'
  //     },
  //     {
  //       value: 2,
  //       label: '负债'
  //     },
  //     {
  //       value: 3,
  //       label: '权益'
  //     },
  //     {
  //       value: 4,
  //       label: '成本'
  //     },
  //     {
  //       value: 5,
  //       label: '损益'
  //     }
  //   ]
  // },
  // 现金流量方向
  cashFlowDirection: {
    list: [
      {
        value: -1,
        label: '全部方向'
      },
      {
        value: 1,
        label: '现金流入'
      },
      {
        value: 0,
        label: '现金流出'
      }
    ]
  },
  // 会计科目属性
  subjectType: {
    list: [
      {
        value: 'A01',
        label: '现金科目'
      },
      {
        value: 'A02',
        label: '银行科目'
      },
      {
        value: 'A03',
        label: '现金等价物'
      },
      {
        value: 'A04',
        label: '一般科目'
      }
    ]
  }
}
